export default "__VITE_ASSET__DPUNHImY__"